module.exports = __webpack_public_path__ + "img/klipper_logo.jpg";